module.exports = __webpack_public_path__ + "img/29.8b07d48b.webp";